import { Box, Typography } from "@mui/material";
import BszSlot from "./BszSlot";
import { useTheme } from "@mui/material/styles";

export default function RoomSlotsSection({
  title,
  slots,
  type,
  onReserve,
  serverNow, // ✅ ADD THIS
}) {
  const theme = useTheme();

  if (!slots || slots.length === 0) return null;

  return (
    <Box sx={{ mt: 2 }}>
      <Typography
        variant="caption"
        sx={{
          fontWeight: 600,
          color: theme.palette.text.secondary,
          mb: 0.5,
        }}
      >
        {title}
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        {slots.map((slot) => (
          <BszSlot
            key={slot.id}
            slot={slot}
            type={type}
            onReserve={onReserve}
            serverNow={serverNow} // ✅ PASS IT DOWN
          />
        ))}
      </Box>
    </Box>
  );
}
